import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { formLibraryRoute } from "../routes";

export default class FormLibraryAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, formLibraryRoute, "form-library");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }

    async Adopt(id) {
        const result = await this._request("post", this._url(`/${id}/adopt`));
        this._emit("adopt", result.id);
        return result;
    }
}
